import React from "react";

const CommonCardList = ({ cardsList }) => {
  return cardsList?.map((obj) => {
    return (
      <option value={obj.id} key={obj.id}>
        {`${obj.card.brand} ending with ${obj.card.last4}`}
      </option>
    );
  });
};

export default CommonCardList;
